import {token} from './localStorage';

const auth = {
  loggedIn() {
    if(token.getEncoded()){
      return (token.getDecoded().exp > new Date().getTime()/1000);
    }else {
      return false;
    }
  },
};

export default auth;



// WEBPACK FOOTER //
// ./src/libs/auth.js